const initSentry = () => {
    const releaseDetails = $f.mobile.settings.get_release_details();
    let userContext;

    if ($f.active_user.is_logged_in()) {
        userContext = {
            id: $f.active_user.id,
            email: $f.active_user.get('email'),
            company: $f.active_company.get('name')
        };
    } else {
        userContext = undefined;
    }

    // Load sentry
    const sentry = $f.mobile.logging.get_sentry();
    const scope = sentry.getCurrentScope();
    scope.setTag('device', releaseDetails.device);
    scope.setTag('release_native', releaseDetails.release_native);
    scope.setTag('base_url', API_URL);

    if (userContext) {
        scope.setUser(userContext);
    }

    // we are setting the release in this way because we don't have the release info
    // in the load_sentry method.
    scope.addEventProcessor((event) => {
        event.release = releaseDetails.release_native;
        return event;
    });
};

export default initSentry;
